import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardRadius: '20px',
  textColorDark: colors.graphite,
  textColorLight: colors.white
};
export default imageSlider;